<template>
	<link href="css/base.css" rel="stylesheet" />

	<div>
		<div class="container-sm prodMain">
			<div class="row align-items-start">
				<div class="col-3"></div>

				<div class="col-1">&nbsp;</div>

				<div class="col-8">
					<div class="pageTitle">
						<img
							id="iconShoppingCart"
							class="img-fluid"
							src="images\shoppingCartIcon.png"
							onerror="this.onerror=null; this.src='images/placeholder_CompanyLogo.png'"
						/>
						<span class="spanTitle">Payment</span>
					</div>

					<div v-if="message" class="alert alert-warning">
						{{ message }}
					</div>
					<div v-if="message" class="support">
						If you are having difficulties please contact us for
						support at
						<a href="mailto:support@elearnology.ca"
							>info@elearnology.ca</a
						>
					</div>
				</div>
			</div>
		</div>

		<div v-if="orderSummary" class="container-sm prodMain prodMainShort">
			<div class="row align-items-start">
				<div class="col-3">
					<div class="brandLogoWrapper">
						<img
							id="brandLogo"
							class="img-fluid"
							:src="'images/' + item1Logo"
						/>
					</div>
					<div>
						<img
							id="prodImgThumnb"
							class="img-fluid"
							:src="'images/' + item1SideImage"
						/>
					</div>
				</div>

				<div class="col-1">&nbsp;</div>

				<div class="col-8">
					<div class="sectionTitle">Order Summary</div>

					<div v-if="orderDetailsReady">
						<!-- <div class="orderSummaryLine">
							<b>Item:</b>
							{{ itemName }}
						</div> -->

						<div class="row cartLine cartLineFirst">
							<div class="col-sm-8 label">{{ itemName }}</div>
							<div class="col-sm-4 fee">
								<span class="feeBlock"
									>{{ formatCurrency(subTotal) }}
									{{ currency.toUpperCase() }}</span
								>
								<!-- <span class="billAnnual">(billed annually)</span> -->
							</div>
						</div>

						<div v-if="DiscountAmt != 0" class="row cartLine">
							<div class="col-sm-8 label">
								Discount Applied: {{ DiscountAppliedLabel }}
							</div>
							<div class="col-sm-4 feeDisc">
								<span class="feeBlock">
									-{{ formatCurrency(DiscountAmt) }}
									{{ currency.toUpperCase() }}</span
								>
								<!-- <span class="billAnnual">(billed annually)</span> -->
							</div>
						</div>

						<div v-if="DiscountAmt != 0" class="row cartLine">
							<div class="col-sm-8 label">Subtotal:</div>
							<div class="col-sm-4 fee">
								<span class="feeBlock"
									>{{ formatCurrency(preTaxTotal) }}
									{{ currency.toUpperCase() }}</span
								>
								<!-- <span class="billAnnual">(billed annually)</span> -->
							</div>
						</div>

						<!-- <div class="orderSummaryLine">
							<b>Subtotal Amount:</b>
							{{ formatCurrency(subTotal / 100) }}
						</div> -->
						<!-- 
						<div class="orderSummaryLine">
							<b>Discount Applied:</b>
							{{ DiscountAppliedLabel }}
						</div> -->

						<div class="row cartLine">
							<div class="cartLine cartLineFirst label">
								Taxes:
							</div>

							<div v-for="tr in taxRates" :key="tr">
								<div class="row">
									<div class="col-sm-8 taxLabel"></div>
									<div class="col-sm-2 fee">
										{{ tr.tax_rate.display_name }} ({{
											tr.tax_rate.percentage
										}}%):
									</div>
									<div class="col-sm-2 fee">
										<span
											>{{
												formatCurrency(tr.amount / 100)
											}}
											{{ currency.toUpperCase() }}</span
										>
									</div>
								</div>
							</div>

							<!-- <div v-for="tr in taxRates" :key="tr">
								{{ tr.tax_rate.display_name }} ({{ tr.tax_rate.percentage }}%):
								{{ formatCurrency(tr.amount / 100) }}
							</div> -->
						</div>

						<div class="row cartLine">
							<div class="col-sm-8 label">Total:</div>
							<div class="col-sm-4 fee">
								{{ formatCurrency(totalBilledPerInterval) }}
								{{ currency.toUpperCase() }}
							</div>
						</div>

						<!-- <div class="orderSummaryLine">
							<b>Billing Amount:</b>
						</div> -->

						<!-- <div class="orderSummaryLine">
							<b>Billing Interval:</b>
							Per
							{{ recurringInterval }}
						</div> -->
						<div class="row cartLine">
							<div class="col-sm-8 label">Billing Interval:</div>
							<div class="col-sm-4 fee">
								Per {{ recurringInterval }}
							</div>
						</div>
						<!-- <div class="orderSummaryLine">
							<b>Currency:</b>
							{{ currency.toUpperCase() }}
						</div> -->
					</div>

					<div v-else>
						<span class="getOrderDetails">
							<img src="images/Spinner-1s-200px.gif" />
							Setting up Subscription details. Please wait. This may take up to 60 seconds to process.
						</span>
					</div>
				</div>
			</div>
		</div>

		<div v-if="readyForPayment" class="container-sm prodMain">
			<div class="row align-items-start">
				<div class="col-3"></div>

				<div class="col-1">&nbsp;</div>

				<div class="col-8">
					<div class="sectionTitle">Payment Details</div>
					<form
						id="subscribe-form"
						@submit.prevent="SendPaymentDetails"
					>
						<div class="form-group">
							<label class="form-label" for="txtCardholderName "
								>Full Name</label
							>
							<input
								id="txtCardholderName"
								v-model="nameInput"
								type="text"
								class="form-control"
								placeholder="Cardholder Name"
							/>
						</div>

						<div class="form-group">
							<label class="form-label" for="card-element"
								>Card Details</label
							>
							<div class="cardInfoWrapper">
								<div id="card-element"></div>
							</div>
						</div>

						<div class="row footCommandRow">
							<div class="col-md-5">
								<a
									href="#"
									class="btn btn-primary butCheckOut"
									@click.prevent="butBack()"
								>
									Back to Terms & Conditions
								</a>
							</div>
							<div class="col-md-2"></div>
							<div class="col-md-5">
                                <div v-if="showSubmitPaymentButton">
                                    <button
                                        class="btn btn-primary butCheckOut"
                                        type="submit"
                                    >
                                        Complete Payment
                                    </button>
                                </div>
                                 <div v-else>
                                    <button disabled
                                        class="btn btn-primary butCheckOut"
                                        type="button"
                                    >
                                        Complete Payment
                                    </button>
                                </div>
							</div>
						</div>
					</form>

					<!-- <div class="testInfo">
						<p>
							<b>TEST VALUES</b>
						</p>
						<p>
							Try the successful test card:
							<span>4242424242424242</span>.
						</p>

						<p>
							Try the test card that requires SCA:
							<span>4000002500003155</span>.
						</p>

						<p>
							Use any
							<i>future</i> expiry date, CVC, and 5 digit postal
							code.
						</p>
					</div> -->
				</div>
			</div>
		</div>

		<div v-if="paymentSuccessMessage" class="container-sm prodMain">
			<div class="row align-items-start">
				<div class="col-3"></div>
				<div class="col-1">&nbsp;</div>
				<div class="col-8">
					<div class="successMessage">
						<div class="title">Payment Successful!</div>

						<p>
							Thanks for your purchase! We've emailed a receipt to
							the email address you provided.
						</p>

						<p>
							Setting up your LMS account, this may take a
							minute...
						</p>
					</div>
				</div>
			</div>
		</div>

		<div v-if="successMessage" class="container-sm prodMain">
			<div class="row align-items-start">
				<div class="col-3"></div>
				<div class="col-1">&nbsp;</div>
				<div class="col-8">
					<div class="successMessage">
						<div class="title">Account Setup Successful!</div>

						<p>
							We've set up your new LMS for you. You can use your
							email and the password you just created to log in.
						</p>

						<template v-if="loginURL2">
							<p>Your new LMS site is ready to go!</p>
							<p>
								<a class="btn btn-primary" :href="loginURL">
									Login
								</a>
							</p>
						</template>
						<template v-else>
							<p>
								Your new LMS site will be ready to go in
								{{ timerCountRounded }} seconds...
							</p>
						</template>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js";
import {
	Cart,
	// CartItem,
	// Coupon,
	// TaxRate,
	CartUtils,
} from "@/components/classes/Cart.js";
import {
	CustomerDetail,
	CustomerDetailsUtils,
} from "@/components/classes/CustomerDetail.js";
import * as Sentry from "@sentry/vue";

var formatter = new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "USD",
	// These options are needed to round to whole numbers if that's what you want.
	//minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
	//maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

let billingControllerURL = ""; //"http://localhost:64006/store/api/billing/";
let LmsSetupControllerURL = ""; //"http://localhost:64006/store/api/lmssetup/";
let apiKey = "";

export default {
	name: "Payment",
	components: {},
	emits: ["eventname"],

	setup() {},
	data() {
		return {
			nameInput: "",
			publishableKey: "",
			stripe: [],
			cardElement: [],
			message: "",
			subscriptionId: "",
			clientSecret: "",
			readyForPayment: true,
			totalBilledPerInterval: 0,
			recurringInterval: "",
			itemName: "",
			currency: "",
			successMessage: false,
			loginURL: "",
			Subscription: {},
			orderDetailsReady: false,
			StripeCoupon: {},
			DiscountAppliedLabel: "",
			DiscountAmt: 0,
			subTotal: 0,
			taxRates: {},
			preTaxTotal: 0,
			timerCount: 30.0,
			timerEnabled: false,
			loginURL2: "",
			timerCountRounded: 0,
			item1Logo: "",
			item1SideImage: "",
			paymentSuccessMessage: false,
			orderSummary: true,
            showSubmitPaymentButton: false,
		};
	},
	watch: {
		loginURL(value) {
			try {
				if (value !== "") {
					this.timerEnabled = true;
				}
			} catch (e) {
				console.log("loginURL", e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},
		timerEnabled(value) {
			try {
				if (value) {
					setTimeout(() => {
						this.timerCount = this.timerCount - 0.5;
					}, 500);
				}
			} catch (e) {
				console.log("timerEnabled", e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},

		timerCount: {
			handler(value) {
				try {
					if (value > 0) {
						this.timerCountRounded = Math.round(value);
						setTimeout(() => {
							this.timerCount = this.timerCount - 0.5;
						}, 500);
					} else {
						this.loginURL2 = "show";
						this.timerCount = 0;
					}
				} catch (e) {
					console.log("timerCount", e);
					//add sentry catch error line here
					Sentry.captureException(e);
				}
			},
			immediate: true, // This ensures the watcher is triggered upon creation
		},
	},
	mounted() {
		try {
			billingControllerURL = this.apiBaseUrl + "Billing/";
			LmsSetupControllerURL = this.apiBaseUrl + "Lmssetup/";
			apiKey = this.apiKey;
			//get stripe pub key and set up card element
			// const myAppearance = {
			// 	theme: "stripe",
			// };

			console.log("calling GetConfig");
			fetch(billingControllerURL + "GetConfig", {
				method: "get",
				headers: {
					"Content-Type": "application/json",
					XApiKey: apiKey,
				},
			})
				.then(async (response) => {
					if (response === undefined) {
						throw new Error(
							"Payment - GetConfig - response is undefined"
						);
					}
					if (!response.ok) {
						return response.text().then((text) => {
							throw new Error(text);
						});
					} else {
						return response.json();
					}
				})
				.then(async (resp) => {
					if (resp == undefined) {
						throw new Error(
							"Payment - GetConfig - resp is undefined"
						);
					}

					this.publishableKey = resp.publishableKey;
					this.stripe = await loadStripe(this.publishableKey);

					// const elements = this.stripe.elements({ appearance: myAppearance });
					const elements = this.stripe.elements();

					// Create an instance of the card Element
					this.cardElement = elements.create("card");

					// this.cardElement.update({ locale: "ca" });

					// this.cardElement = elements.create('card');
					this.cardElement.mount("#card-element");
				})
				.catch((e) => {
					console.error("Error GetConfig:", e);
					this.message =
						"Oops, looks like there was an error. (GC-1) Details: " +
						e;
					Sentry.captureException(e);
					ctx.scrollToTop();
				});

			//create subscription id for item in cart

			let newCart = new Cart();
			let cartUtils = new CartUtils();
			let priceId = "";

			if (localStorage.getItem("cart")) {
				// try {
				newCart = cartUtils.reviveCartObj();
				var ci = newCart.CartItems[0];

				if (ci.product.productLms.brand.imgLogo != "") {
					this.item1Logo = ci.product.productLms.brand.imgLogo;
				}

				if (ci.product.productLms.brand.imgCartSideImage != "") {
					this.item1SideImage =
						ci.product.productLms.brand.imgCartSideImage;
				}

				if (ci.useAnnualBilling) {
					priceId = ci.stripePriceIdYearly;
				} else {
					priceId = ci.stripePriceIdMonthly;
				}

				let getCustDetail = new CustomerDetail();

				if (localStorage.getItem("customerDetail")) {
					let custDetUtils = new CustomerDetailsUtils();

					getCustDetail = custDetUtils.reviveCustomerDetailObj();

					if (
						getCustDetail.Email != undefined &&
						getCustDetail.Email != ""
					) {
						// getCustDetail.FirstName;
						// getCustDetail.LastName;
						// getCustDetail.Address;
						// getCustDetail.AptSuite;
						// getCustDetail.City;
						// getCustDetail.PostalCode;
						// getCustDetail.CountryCode;
						// getCustDetail.Country;
						// getCustDetail.ProvStateCode;
						// getCustDetail.ProvState;
						// getCustDetail.Email;
						// getCustDetail.Phone;

						let tempUpcomingInvoice = JSON.parse(
							localStorage.getItem("upcomingInv")
						);
						let customerId = tempUpcomingInvoice.customer;

						// let couponId = newCart.Coupon.Id;

						var ctx = this;
						// var couponID = "";

						// if (newCart.Coupon != null) {
						// 	if (newCart.Coupon.Id != null) {
						// 		couponID = newCart.Coupon.Id;
						// 	}
						// }

						// let bodyJSON = {
						//     email: "email@incompleteorder.com",
						//     ipAddress: getIP,
						//     ipCountry: countryCode,
						//     ipCity: cityCode,
						//     ipState: stateCode,
						//     ipPostal: postalCode,
						//     priceId: priceId,
						//     address: "",
						//     stripeCustId: "",
						//     stripeCouponId: "",
						//     firstName: "",
						//     lastName: "",
						// };

						var bodyJSON = JSON.stringify({
							email: ctx.checkNull(getCustDetail.Email, "str"),
							// ip_address: getIP,
							ipCountry: ctx.checkNull(
								getCustDetail.CountryCode,
								"str"
							),
							// city: cityCode,
							ipState: ctx.checkNull(
								getCustDetail.ProvStateCode,
								"str"
							),
							ipPostal: ctx.checkNull(
								getCustDetail.PostalCode,
								"str"
							),
							priceId: ctx.checkNull(priceId, "str"),
							address: ctx.checkNull(
								getCustDetail.Address,
								"str"
							),
							stripeCustId: ctx.checkNull(customerId, "str"),
							stripeCouponId: ctx.checkNull(
								newCart?.Coupon?.Id,
								"str"
							),
							firstName: ctx.checkNull(
								getCustDetail.FirstName,
								"str"
							),
							lastName: ctx.checkNull(
								getCustDetail.LastName,
								"str"
							),
						});

						console.log("calling CreateCustomerGetTaxRate");
						fetch(
							billingControllerURL + "CreateCustomerGetTaxRate",
							{
								method: "post",
								headers: {
									"Content-Type": "application/json",
									XApiKey: apiKey,
								},
								body: bodyJSON,
							}
						)
							.then(function (response) {
								if (response === undefined) {
									throw new Error(
										"Payment - mounted - CreateCustomerGetTaxRate - response is undefined"
									);
								}
								if (!response.ok) {
									return response.text().then((text) => {
										throw new Error(text);
									});
								} else {
									return response.json();
								}
							})
							.then(function (jsonResponse) {
								if (jsonResponse === undefined) {
									throw new Error(
										"Payment - mounted - CreateCustomerGetTaxRate - jsonResponse is undefined"
									);
								}
								var customer = jsonResponse.customer;

								//we actually create a pending subscription (unused) here with the priceid **********
								// var upcomingInvoice = jsonResponse.invoice;

								// if (newCart.Coupon != null) {
								// 	if (newCart.Coupon.Id != null) {
								// 		couponID = newCart.Coupon.Id;
								// 	}
								// }

								let bodyJSON = JSON.stringify({
									priceId: ctx.checkNull(priceId, "str"),
									customerId: ctx.checkNull(
										customer.id,
										"str"
									),
									stripeCouponId: ctx.checkNull(
										newCart?.Coupon?.Id,
										"str"
									),
								});

								//get priceId from cart
								if (priceId != "" || customer.id != "") {
									console.log("calling CreateSubscription");
									fetch(
										billingControllerURL +
											"CreateSubscription",
										{
											method: "POST",
											headers: {
												"Content-Type":
													"application/json",
												XApiKey: apiKey,
											},
                                            body: bodyJSON,
                                            timeout: 300000, //wait 5 minutes for this api response - long running
										}
									)
										.then((response) => {
											if (response === undefined) {
												throw new Error(
													"Payment - mounted - CreateSubscription - response is undefined"
												);
											}
											console.log(
												"CreateSubscription response status",
												response.status
											);
											if (!response.ok) {
												return response
													.text()
													.then((text) => {
														throw new Error(text);
													});
											} else {
												return response.json();
											}
										})
										.then((data) => {
											if (data === undefined) {
												throw new Error(
													"Payment - mounted - CreateSubscription - data is undefined"
												);
											}
											ctx.subscriptionId = ctx.checkNull(
												data.subscriptionId,
												"str"
											);
											ctx.clientSecret = ctx.checkNull(
												data.clientSecret,
												"str"
											);

											ctx.totalBilledPerInterval =
												ctx.checkNull(
													parseFloat(
														data.totalBilledPerInterval /
															100
													),
													"str"
												);

											ctx.recurringInterval =
												ctx.checkNull(
													data.recurringInterval,
													"str"
												);

											ctx.itemName = ctx.checkNull(
												data.itemName,
												"str"
											);

											ctx.currency = ctx.checkNull(
												data.currency,
												"str"
											);

											ctx.Subscription = ctx.checkNull(
												JSON.parse(
													data.subscriptionJson
												),
												"str"
											);

											

											let latestInv =
												ctx.Subscription.latest_invoice;

											// if (latestInv.discount != null) {
											// 	if (latestInv.discount.coupon != null) {
											// 		ctx.StripeCoupon = latestInv.discount.coupon;
											// 	}
											// }

											ctx.StripeCoupon = ctx.checkNull(
												latestInv?.discount?.coupon,
												"str"
											);

											ctx.subTotal =
												parseFloat(latestInv.subtotal) /
												100;

											ctx.taxRates =
												latestInv.total_tax_amounts;

											//latestInv.total_tax_amounts[0].amount
											//latestInv.total_tax_amounts[0].tax_rate.display_name
											//latestInv.total_tax_amounts[0].tax_rate.percentage

											if (
												ctx.StripeCoupon.amount_off !=
												null
											) {
												ctx.DiscountAmt = parseFloat(
													latestInv
														.total_discount_amounts[0]
														.amount / 100
												);

												ctx.DiscountAppliedLabel =
													"-" +
													formatter.format(
														latestInv
															.total_discount_amounts[0]
															.amount / 100
													);
											}

											if (
												ctx.StripeCoupon.percent_off !=
												null
											) {
												ctx.DiscountAmt = parseFloat(
													latestInv
														.total_discount_amounts[0]
														.amount / 100
												);
												ctx.DiscountAppliedLabel =
													// "-" +
													// formatter.format(
													// 	latestInv.total_discount_amounts[0].amount / 100
													// ) +
													" (-" +
													ctx.StripeCoupon
														.percent_off +
													"%)";
											}

											ctx.preTaxTotal =
												parseFloat(
													latestInv.subtotal / 100
												) - ctx.DiscountAmt;

                                            ctx.orderDetailsReady = true;
                                            ctx.showSubmitPaymentButton = true;
										})
										.catch((error) => {
											console.error(
												"Error CreateSubscription:",
												error
											);
											Sentry.captureException(error);
											ctx.message =
												"Oops, looks like there was an error. (CS-1) Details: " +
												error;
											ctx.scrollToTop();
											//hide payment panel and let user choose back button.
											//show payment panel
											ctx.readyForPayment = false;
										});
								} else {
									//no priceid
									ctx.message =
										"Oops, looks like there was an error. 1 Details: PriceID missing";
									throw new Error(
										"Payment - mounted - CreateSubscription - PriceID missing"
									);
								}
							})
							.catch((error) => {
								console.error(
									"Error CreateCustomerGetTaxRate:",
									error
								);
								Sentry.captureException(error);
								ctx.message =
									"Oops, looks like there was an error. (CCGTR-1) Details: " +
									error;
							});
					} else {
						//cust email is empty
						this.message =
							"Oops, looks like there was an error. Details: Customer email missing.";
					}
				} else {
					//cust detail is empty
					this.message =
						"Oops, looks like there was an error. Details: customer details missing.";
				}
				// } catch (e) {
				// 	//localStorage.removeItem('cart');
				// }
			} else {
				//cart is empty empty
				this.message =
					"Oops, looks like there was an error. Details: Cart is empty.";
			}
		} catch (e) {
			console.log("mounted", e);
			//add sentry catch error line here
			Sentry.captureException(e);
		}
	},
	methods: {
		scrollToTop() {
			try {
				window.scrollTo(0, 0);
			} catch (e) {
				console.log("scrollToTop", e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},
		// playCountdown(RedirectURL) {
		playCountdown() {
			try {
				this.timerEnabled = true;
			} catch (e) {
				console.log("playCountdown", e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},

		pauseCountdown() {
			try {
				this.timerEnabled = false;
			} catch (e) {
				console.log("pauseCountdown", e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},

		formatCurrency: function (price) {
			try {
				let priceString = formatter.format(price);
				return priceString;
			} catch (e) {
				console.log("formatCurrency", e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},

		checkNull: function (obj, objType) {
			try {
				if (obj != null) {
					return obj;
				} else {
					if (objType == "str") {
						return "";
					}
					if (objType == "bool") {
						return false;
					}
					if (objType == "int") {
						return 0;
					}
					if (objType == "float") {
						return 0;
					}
				}
				return "";
			} catch (e) {
				console.log("checkNull", e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},

		SendPaymentDetails() {
			try {
				var ctx = this;
				ctx.message = "";

				// Create payment method and confirm payment intent.
				console.log("calling confirmCardPayment");
				this.stripe
					.confirmCardPayment(this.clientSecret, {
						payment_method: {
							card: this.cardElement,
							billing_details: {
								name: this.nameInput,
							},
						},
						setup_future_usage: "off_session",
					})
					.then(function (result) {
						if (result === undefined) {
							throw new Error(
								"Payment - SendPaymentDetails - result is undefined"
							);
						}
						if (result.error) {
							console.log(result.error.message);
							ctx.message =
								"Oops, looks like there was an error. (SPD-1) Details: " +
								result.error.message;
							Sentry.captureException(result.error.message);
							ctx.scrollToTop();
						} else {
							// Redirect the customer to their account page
							// setMessage('Success! Redirecting to your account.');
							// window.location.href = '/account.html';
							console.log(result);
							let pi = result.paymentIntent;

							if (pi.status == "succeeded") {
								//relevant values-----------------------------------
								//pi.id = 'pi_3KYDoaLs6H5jfmsP0vJJWWfh'
								//pi.status == 'succeeded'
								//pi.created == '1646072360'
								//pi.client_secret

								//Subscription successfull

								//1 - trigger set up LMS account here
								//api call to .NET to do the following:

								//create new LMS account
								//create new user and make member of the new LMS account as admin user
								//send welcome email
								// - do we need to send a custom invoice email?

								ctx.readyForPayment = false;
								ctx.orderSummary = false;
								//hide payment panel
								ctx.paymentSuccessMessage = true;
								ctx.successMessage = false;

								let newCart = new Cart();
								let cartUtils = new CartUtils();
								// let priceId = "";

								if (localStorage.getItem("cart")) {
									// try {
									newCart = cartUtils.reviveCartObj();
									var ci = newCart.CartItems[0];

									// if (ci.useAnnualBilling) {
									// 	priceId = ci.stripePriceIdYearly;
									// } else {
									// 	priceId = ci.stripePriceIdMonthly;
									// }

									let cd = new CustomerDetail();

									if (
										localStorage.getItem("customerDetail")
									) {
										let custDetUtils =
											new CustomerDetailsUtils();

										cd =
											custDetUtils.reviveCustomerDetailObj();

										if (
											cd.Email != undefined &&
											cd.Email != ""
										) {
											var taxRatesArray = [];

											let total_tax_amounts =
												ctx.Subscription.latest_invoice
													.total_tax_amounts;

											for (let idx in total_tax_amounts) {
												let tx = total_tax_amounts[idx];

												taxRatesArray.push({
													taxLabel:
														tx.tax_rate
															.display_name,
													taxAmt: parseFloat(
														tx.amount / 100
													),
												});
											}
											var taxRates =
												JSON.stringify(taxRatesArray);

											let inv =
												ctx.Subscription.latest_invoice;
											let itm =
												ctx.Subscription.latest_invoice
													.lines.data[0];

											// let activeMonthList = [
											// 	{ monthOrder: 1, isActive: false },
											// 	{ monthOrder: 2, isActive: false },
											// 	{ monthOrder: 3, isActive: false },
											// 	{ monthOrder: 4, isActive: false },
											// 	{ monthOrder: 5, isActive: false },
											// 	{ monthOrder: 6, isActive: false },
											// 	{ monthOrder: 7, isActive: false },
											// 	{ monthOrder: 8, isActive: false },
											// 	{ monthOrder: 9, isActive: false },
											// 	{ monthOrder: 10, isActive: false },
											// 	{ monthOrder: 11, isActive: false },
											// 	{ monthOrder: 12, isActive: false },
											// ];
											let calcDisc =
												parseFloat(
													inv
														?.total_discount_amounts[0]
														?.amount
												) / 100;
											if (isNaN(calcDisc)) {
												calcDisc = 0;
											}

											let bodyJSON = JSON.stringify({
												email: cd.Email,
												password: cd.Password,
												firstName: cd.FirstName,
												lastName: cd.LastName,
												address: cd.Address,
												aptSuite: cd.AptSuite,
												city: cd.City,
												country: cd.Country,
												countryCode: cd.CountryCode,
												phone: cd.Phone,
												postalCode: cd.PostalCode,
												provState: cd.ProvState,
												provStateCode: cd.ProvStateCode,

												prodId: ci.product.id,
												isAnnualBilling:
													ci.useAnnualBilling,
												coupon: newCart?.Coupon?.Id,

												stripeSubscriptionId:
													ctx.Subscription.id,
												createdDate:
													ctx.Subscription.created,

												stripeCustomerId: inv.customer,

												currentPeriodEndDate:
													ctx.Subscription
														.current_period_end,
												currentPeriodStartDate:
													ctx.Subscription
														.current_period_start,

												stripePaymentIntentId: pi.id,

												currency: itm.currency,
												stripePriceId: itm.price.id,
												stripeProductId:
													itm.price.product,

												discount: calcDisc,

												// discountName:
												// 	ctx.Subscription.discount
                                                //         ?.coupon?.name,
                                                        
                                                discountName: ctx.checkNull(
												    ctx.Subscription?.discount
                                                        ?.coupon?.name,
												    "str"
											    ),


												subTotal: parseFloat(
													inv.subtotal / 100
												),
												total: parseFloat(
													inv.total / 100
												),
												taxRates: taxRates,
												activeMonthList:
													ci.activeMonthList,
											});

											console.log(
												"calling CreateCustomerLMSAccount"
											);
											fetch( 
												LmsSetupControllerURL +
													"CreateCustomerLMSAccount",
												{
													method: "post",
													headers: {
														"Content-Type":
															"application/json",
														XApiKey: apiKey,
													},
													body: bodyJSON,
                                                    timeout: 300000, //wait 5 minutes for this api response - long running
												}
											)
												.then(async (response) => {
													if (
														response === undefined
													) {
														throw new Error(
															"Payment - CreateCustomerLMSAccount - response is undefined"
														);
													}
													if (!response.ok) {
														return response
															.text()
															.then((text) => {
																throw new Error(
																	text
																);
															});
													} else {
														return response.json();
													}
												})
												.then((data) => {
													if (data === undefined) {
														throw new Error(
															"Payment - CreateCustomerLMSAccount - data is undefined"
														);
													}
													if (data.success) {
														if (
															data.redirectURL !=
															null
														) {
															//2 - trigger subscription receipt email
															//Stripe can automatically create a receipt if feature is activated.
															//this would be be basic and unstyled

															//display success message, with link to login page
															ctx.readyForPayment = false;
															//hide payment panel
															ctx.paymentSuccessMessage = false;
															ctx.successMessage = true;
															ctx.timerCount = 30;
															ctx.playCountdown(
																data.RedirectURL
															);

															if (
																localStorage.getItem(
																	"cart"
																)
															) {
																//default url
																ctx.loginURL =
																	data.redirectURL;

																//pull url from brand record
																// let cartUtils = new CartUtils();
																// let newCart = cartUtils.reviveCartObj();
																// let url =
																// 	newCart.CartItems[0].product.ProductLms
																// 		.Brand.PrimaryDomain.Domain;

																// if (url != "") {
																// 	ctx.loginURL = "https://" + url;
																// }
															}

															//remove localstorage variables from browser memory
															RemoveStorageItem(
																"cart"
															);
															RemoveStorageItem(
																"customerDetail"
															);
															RemoveStorageItem(
																"taxrates"
															);
															RemoveStorageItem(
																"upcomingInv"
															);
														} else {
															console.error(
																"Error:",
																data
															);
															ctx.message =
																"Oops, looks like there was an error saving your order. "; //Details: ";
															// +
															// data.statusText +
															// " (" +
															// data.status +
															// ")";
														}
													} else {
														//setup failed
														console.error(
															"Error:",
															data.message
														);
														Sentry.captureException(
															data.message
														);
														ctx.message =
															"Oops, looks like there was an error saving your order. (" +
															data.message +
															")";
														ctx.scrollToTop();
													}
												})
												.catch((error) => {
													console.error(
														"Error:",
														error
													);
													Sentry.captureException(
														error
													);
													ctx.message =
														"Oops, looks like there was an error setting up your account. Please contact support for assistance. (CCLA-1) Details: " +
														error;
												});
										} else {
											//email empty
											throw new Error(
												"Payment - CreateCustomerLMSAccount - Email is empty"
											);
										}
									} else {
										//couldn't load customerDetail from localstorage
										throw new Error(
											"Payment - CreateCustomerLMSAccount - CustomerDetail is empty"
										);
									}
								} else {
									//couldn't load cart from localstorage
									throw new Error(
										"Payment - CreateCustomerLMSAccount - Cart is empty"
									);
								}
							} else {
								//could not activate subscription
								ctx.message =
									"Oops, looks like we could not activate the subscription with the current card information. "; //Details: " + error;
								throw new Error(
									"Payment - CreateCustomerLMSAccount - Subscription activation failed"
								);
							}
						}
					})
					.catch((error) => {
						console.error("Error:", error);
						Sentry.captureException(error);
						ctx.message =
							"Oops, looks like there was an error. (CCP-1) Details: " +
							error.code +
							" - " +
							error.message;
					});
			} catch (e) {
				console.log("SendPaymentDetails", e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},

		butBack() {
			try {
				this.$emit("eventname", "Terms");
			} catch (e) {
				console.log("butBack", e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},
	}, //end of methods
};

function RemoveStorageItem(str) {
	try {
		if (localStorage.getItem(str)) {
			localStorage.removeItem(str);
		}
	} catch (e) {
		console.log("RemoveStorageItem", e);
		//add sentry catch error line here
		Sentry.captureException(e);
	}
}
</script>

<style scoped>
.formDiv {
	padding-bottom: 30px;
}

.prodMain {
	margin-bottom: 50px;
	max-width: 1000px;
}

.prodMainShort {
	margin-bottom: 0px !important;
	max-width: 1000px;
}

.prodMain .pageTitle {
	font-size: 30px;
	margin-bottom: 30px;
}
.brandLogoWrapper {
	text-align: center;
}
#brandLogo {
	margin-bottom: 20px;
	/* min-height:100px; */
	/* width:90px;
    height:90px;
    margin-right:auto;
    margin-left: auto; */
	width: 100%;
	max-width: 90px;
}
#prodImgThumnb {
	/* margin-bottom: 50px; */
	min-height: 100px;
	width: 240px;
	height: 260px;
}
.prodMain .prodTitle {
	font-size: 20px;
	margin-bottom: 30px;
	border-bottom: 1px grey solid;
}

.cartLine {
	font-size: 16px;
}
.cartLine .label {
	font-weight: 100;
}
.cartLine .fee {
	text-align: right;
}

.cartLine .feeDisc {
	text-align: right;
	color: red;
}
.floatSwitch {
	float: left;
}
.prodMain .label {
	/* font-weight: 600;
	font-family: Lato Bold, Arial, Helvetica, sans-serif; */
}
.prodPlanType {
	margin-bottom: 20px;
	/* border:1px red solid; */
}
.prodPlanType div {
	padding: 0px;
	/* padding-left: 12px; */
	/* border:1px red solid;  */
}
.planTypeLabel {
	margin-left: 10px;
}
.prodDesc {
	margin-bottom: 20px;
}
.prodFee {
	margin-bottom: 20px;
}

.prodCoupon {
	margin-bottom: 20px;
}
.cartLine {
	margin-bottom: 10px;
	border-top: 1px #ddd solid;
	padding-top: 10px;
}

.cartLineFirst {
	margin-bottom: 10px;
	border-top: 0px #ddd solid;
	padding-top: 0px;
}
.billAnnual {
	font-size: 12px;
	display: block;
	clear: both;
	color: rgb(90, 89, 89);
}
.feeBlock {
	display: block;
	clear: both;
}
.footCommandRow {
	border-top: 1px #ddd solid;
	margin-top: 40px;
	padding-top: 20px;
	text-align: right !important;
}
a.butRemove {
	font-size: 8px;
	padding: 2px;
}

.form-switch .form-check-input {
	/* width: 2em; */
	margin-left: 0em;
}
.form-check .form-check-input {
	/* float: left; */
	margin-left: 0;
}
/* .planTypeLabel {
   
} */

.btn {
	margin-bottom: 20px;
}

.btn-primary,
.btn-primary:hover {
	background-color: #a9cf3c;
	border-color: #a9cf3c;

	font-weight: 600;
	font-family: Lato Bold, Arial, Helvetica, sans-serif;
}

.butCheckOut,
.butCheckOut:hover {
	width: 100%;
}
button.butCheckOut {
	margin-top: 0px;
}


 .butCheckOut:disabled {
    color: #fff;
    background-color: #ccc;
    border-color: #ccc;
}


.row {
	--bs-gutter-x: 0rem;
}
.iconShoppingCart {
	padding: 0px;
	margin: 0px;
	margin-right: 10px;
}
.spanTitle {
	padding-left: 20px;
}
.colRemoveButton {
	text-align: right;
}
.discountDisc {
	font-size: 12px;
	color: #a9cf3c;
	font-style: italic;
}
.discAmt {
	color: #a9cf3c;
}
.alertVal {
	display: block;
	margin-top: 5px;
	padding: 5px;
	padding-left: 10px;
	padding-right: 10px;
}
.sectionTitle {
	font-size: 20px;
	border-bottom: 1px #ddd solid;
	padding-bottom: 5px;
	margin-bottom: 20px;
	/* margin-top: 40px; */
	color: #a9cf3c;
}
form label span {
	display: block;
	font-size: 12px;
	color: #aaa;
}

.testInfo {
	font-size: 10px;
	color: #aaa;
}
.cardInfoWrapper {
	border: 1px #ced4da solid;
	padding: 10px;

	border-radius: 5px;
}

.orderSummaryLine {
	font-size: 16px;
	padding: 0px;
	margin: 0px;
	margin-bottom: 10px;
}

.successMessage {
	border: 1px #a9cf3c solid;
	padding: 40px;
	font-size: 14px;
	border-radius: 5px;
}

.successMessage .title {
	color: #a9cf3c;
	font-size: 30px;
	margin-bottom: 20px;
}

.successMessage p {
	font-size: 18px;
	margin-bottom: 20px;
}

.successMessage a.butGoToLogin {
}

.getOrderDetails {
	height: 40px;
	display: block;
	position: relative;
	padding-left: 35px;
	padding-top: 5px;
}
.getOrderDetails img {
	width: auto;
	height: 100%;
	left: -10px;
	position: absolute;
	top: 0px;
	float: left;
}

.support {
	color: #aaa;
	display: block;
	margin-top: 0px;
	padding: 0px;
	padding-left: 15px;
	padding-right: 15px;

	/*
    border-top:1px #ccc solid;
    padding-top:5px;*/
}

.support a {
	color: #a9cf3c;
	text-decoration: none;
}
.pmtButtonRow {
	margin-top: 15px;
}
</style>